// test1523
(1523 && 0);
